<template>
  <section class="p_check_c">
    <div class="p_check_title">{{scheduledList[0].progressName}}</div>
    <el-row class="p_check_row p_check_line_h">
      <el-col :span="24" class="p_check_l">
          <iframe src="" ref="modelViewOne"  class="model_view_frame"></iframe>
      </el-col>
    </el-row>
    <div class="p_check_title">{{scheduledList[1].progressName}}</div>
    <el-row class="p_check_row p_check_line_h">
      <el-col :span="24" class="p_check_l">
          <iframe src="" ref="modelViewTwo"  class="model_view_frame"></iframe>
      </el-col>
    </el-row>
  </section>
</template>

<script>
  import {detailModel} from '../../api/api'
  import CheckEngine from "./CheckEngine";
  import CheckGantt from "./CheckGantt"
  export default {
    name: "CheckView",
    components: {CheckEngine,CheckGantt},
    props:{
      scheduledList:Array
    },
    data(){
      return {
        model1:{},
        scheduledId1:null,
      }
    },
    mounted() {
      this.$refs.modelViewOne.src = "/checkengine?scheduledId="+this.scheduledList[0].id
        +"&modelId="+this.scheduledList[0].modelId+"&proId="+this.scheduledList[0].proId

      this.$refs.modelViewTwo.src = "/checkengine?scheduledId="+this.scheduledList[1].id
        +"&modelId="+this.scheduledList[1].modelId+"&proId="+this.scheduledList[1].proId

    },
    destroyed() {
    }
  }
</script>

<style scoped>
  .p_check_title{
    height: 30px;
    line-height: 30px;
  }
  .model_view_frame{
    border: 0;
    width: 100%;
    height: 100%;
  }
  .p_check_c {
    height: 760px;
  }
  .p_check_row{
    height: 350px;

  }
  .p_check_line_h{
    border-top: 1px solid #c9c9c9;
  }
  .p_check_l{
    height: 100%;

  }
</style>



// WEBPACK FOOTER //
// src/components/progress/CheckView.vue